import { AppTableHeader } from "../../../../Libraries";

const HeaderItem = ({ I18n }) => {
    return (
        <AppTableHeader className={"fourColumn"}>
            <div className="BoxWidth justifyStart">
                <p className="fontSize14 truncateOneLine darkGrayColor fontWeight500">
                    {I18n.items}
                </p>
            </div>
            <div className="BoxWidth justifyCenter">
                <p className="fontSize14 truncateOneLine darkGrayColor fontWeight500">
                    {I18n.per_item}
                </p>
            </div>
            <div className="BoxWidth justifyCenter">
                <p className="fontSize14 truncateOneLine darkGrayColor fontWeight500">
                    {I18n.qty}
                </p>
            </div>
            <div className="BoxWidth justifyCenter">
                <p className="fontSize14 truncateOneLine darkGrayColor fontWeight500">
                    {I18n.amount}
                </p>
            </div>
        </AppTableHeader>
    );
};

export default HeaderItem;
